import logo from "../assets/images/logo.png";
import axios from "axios";
import { post as HelperPost } from "../API/apiHelper";
import { Alert } from "react-bootstrap";

export async function apiurl(callback) {
  let setting = null;
  let settingFromSession = sessionStorage.getItem("settting");
  if (settingFromSession && settingFromSession != null) {
    setting = JSON.parse(settingFromSession);
  }

  callback(
    setting.razorpay_prod_on === 1
      ? setting.razorpay_prod_key
      : setting.razorpay_key
  );
}
function isMobileDevice() {
  const value =
    /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  console.log("value is ", value);
  return value;
}
const openWindow = (id, amount, RefNo, callback) => {
  const newWindow = window.open(id, "_blank", "width=800,height=600");

  if (newWindow) {
    if (window.history.length > 1) {
    } else {
      // alert("Mobile");
      if (isMobileDevice()) {
        callback({}, amount, RefNo);
        // const interval = setInterval(() => {
        //   const lastPaymentUrl = localStorage.getItem("lastPaymentUrl");
        //   if (lastPaymentUrl) {
        //     alert("lastPaymentUrl");
        //     localStorage.removeItem("lastPaymentUrl");
        //     // Parse the saved URL
        //     const hashPart = lastPaymentUrl.split("#")[1] || "";
        //     const queryString = hashPart.includes("?")
        //       ? hashPart.split("?")[1]
        //       : "";
        //     const params = new URLSearchParams(queryString);
        //     const queryParams = {};
        //     params.forEach((value, key) => {
        //       queryParams[key] = value;
        //     });
        //     alert("✅ Restored Params:", queryParams);
        //     if (queryParams["status"]?.toLowerCase() === "success") {
        //       callback(
        //         { razorpay_payment_id: queryParams["easepayid"] || "n/a" },
        //         amount,
        //         RefNo
        //       );
        //     } else {
        // callback({}, amount, RefNo);
        // }
        // } else {
        // }
        // }, 1000);
      }
      // Start monitoring the window every second
      const interval = setInterval(() => {
        try {
          if (!newWindow || newWindow.closed) {
            // console.log("✅ Window closed by user or script.");
            clearInterval(interval);
          } else {
            let currentURL = "";
            try {
              currentURL = newWindow.location.href || "";
              // console.log(`currentURLcurrentURLcurrentURL ${currentURL}`);
            } catch (error) {
              // alert(`hi yogesh ${error}`);
              // console.log(error);
            }
            // alert("hi yogesh 2");
            // Close if URL changes OR contains "yogesh.com"
            if (
              // currentURL !== "https://api.vivantravels.com/sucess" ||
              currentURL.includes("/#/sucess")
            ) {
              // alert(currentURL);
              // console.log(currentURL);
              const hashPart = currentURL.split("#")[1] || ""; // e.g. "/sucess?param1=abc&param2=123"
              const queryString = hashPart.includes("?")
                ? hashPart.split("?")[1]
                : "";

              const params = new URLSearchParams(queryString);

              // Convert URL parameters to an object
              const queryParams = {};
              params.forEach((value, key) => {
                queryParams[key] = value;
              });

              // console.log("✅ URL Parameters:", queryParams);
              if (queryParams["status"] === "success") {
                callback(
                  { razorpay_payment_id: queryParams["easepayid"] || "n/a" },
                  amount,
                  RefNo
                );
              }
              // console.log(
              //   "🔴 Auto-closing window: URL changed or matched 'yogesh.com'."
              // );
              newWindow.close();
              clearInterval(interval);
            }
          }
        } catch (error) {
          alert("error");
          // console.warn(
          //   "⚠️ Cannot access the URL due to cross-origin restrictions."
          // );
          // Even if cross-origin access is blocked, the window object can still be closed safely
          if (newWindow.closed) {
            clearInterval(interval);
          }
          // newWindow.close();
        }
      }, 1000); // Check every second
    }
  } else {
    alert("Popup blocked! Please allow popups for this site.");
  }
};

// Function to manually close the opened window
const closeWindow = (popupWindow) => {
  if (popupWindow && !popupWindow.closed) {
    popupWindow.close();
  } else {
    alert("No open window found.");
  }
};

export async function razarpaypayment(
  orderId,
  amount,
  description,
  RefNo,
  callback
) {
  let userData;
  const userDataFromSession = sessionStorage.getItem("userData");
  if (userDataFromSession && userDataFromSession != null) {
    userData = JSON.parse(userDataFromSession);
  }
  // console.log(userData?.model);
  var data = {
    txnid: orderId,
    amount: parseFloat(amount).toFixed(2),
    productinfo: description.startsWith("wallet_")
      ? description.replace("wallet_", "")
      : description,
    udf2: String(userData?.model?.id ?? ""),
    udf1: description.startsWith("wallet_") ? "wallet_" : "",
    firstname: description.startsWith("wallet_")
      ? description.replace("wallet_", "")
      : description,
    phone: userData?.model?.mobile_no?.trim()
      ? userData.model.mobile_no
      : "1234567890",
    email: "wsd@gg.com",
  };
  // console.log(JSON.stringify(data));
  const res = await HelperPost("third_party/payment", data, true);
  const resval = await res.json();
  if (resval.data.status == 1) {
    openWindow(resval.url + resval.data.data, amount, RefNo, callback);
  }
  // let res = await loadScript("https://checkout.razorpay.com/v1/checkout.js");
  // if (!res) {
  //     alert("Razorpay SDK failed to load. Are you online?");
  //     return;
  // }
  // let userData = null;
  // let userDataFromSession = sessionStorage.getItem('userData');
  // if (userDataFromSession && userDataFromSession != null) {
  //     userData = JSON.parse(userDataFromSession);
  // }
  // let setting = null;
  // let settingFromSession = sessionStorage.getItem('settting');
  // if (settingFromSession && settingFromSession != null) {
  //     setting = JSON.parse(settingFromSession);
  // }
  // let options = {
  //     key: setting.razorpay_prod_on === 1 ? setting.razorpay_prod_key : setting.razorpay_key,
  //     amount: parseInt(amount * 100),
  //     currency: userData.currency_code || "INR",
  //     name: "Vivan Travels",
  //     description: description,
  //     image: logo,
  //     handler: async (response) =>{
  //       console.log(
  //         `razarpayresponse   ${JSON.stringify(response)} ${
  //           response["razorpay_payment_id"]
  //         } `
  //       );
  //       var data = {
  //         payment_id: response["razorpay_payment_id"],
  //         amount: parseInt(amount * 100),
  //         currency: "INR",
  //         type: setting.razorpay_prod_on === 1,
  //       };
  //       const res = await HelperPost(
  //         "third_party/razorpaycapture",
  //         data,
  //         true
  //       );
  //       console.log(
  //         `razarpayresponse   ${JSON.stringify(response)}   ${JSON.stringify(
  //           res
  //         )}`
  //       );
  //       callback(response, amount, RefNo);
  //     },
  //     prefill: {
  //         name: "Vivan Travels",
  //         email: "test@gmail.com",
  //         contact: userData.mobile_no,
  //     },
  //     notes: {
  //         address: "India",
  //     },
  //     theme: {
  //         color: "#158993",
  //     },
  // };
  // let paymentObject = new window.Razorpay(options);
  // paymentObject.open();
}

let loadScript = (src) => {
  return new Promise((resolve) => {
    let script = document.createElement("script");
    script.src = src;
    script.onload = () => {
      resolve(true);
    };
    script.onerror = () => {
      resolve(false);
    };
    document.body.appendChild(script);
  });
};
